import { useState } from 'react';
import Flex from './Flex';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

type CollapsibleSectionProps = {
    openLabel: string;
    closeLabel?: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
    className?: string;
    justify?: 'center' | 'start' | 'end' | 'stretch' | 'between' | 'around' | 'evenly';
};

const CollapsibleSection = ({
    openLabel,
    closeLabel,
    defaultOpen = false,
    children,
    className,
    justify,
}: CollapsibleSectionProps) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <Flex column>
            <Toggle
                className={className}
                gap="0.5rem"
                align="center"
                justify={justify}
                onClick={() => setOpen((v) => !v)}
            >
                {open ? closeLabel ?? openLabel : openLabel}
                <Chevron icon={faChevronDown} $open={open} />
            </Toggle>
            {open && children}
        </Flex>
    );
};

export default CollapsibleSection;

const Toggle = styled(Flex)`
    cursor: pointer;
    color: ${({ theme }) => theme.colors.text};
    padding: 1rem;
`;

const Chevron = styled(FontAwesomeIcon)<{ $open: boolean }>`
    transition: transform 0.2s ease;
    transform: rotate(${({ $open }) => ($open ? 180 : 0)}deg);
`;
